import { HubConnectionBuilder, LogLevel, type HubConnection } from '@microsoft/signalr';
import { authStore } from '@/stores/auth-store';

/**
 * Même base que `api/client.ts` : origine du document par défaut, résolue paresseusement.
 * `VITE_API_BASE_URL` en dev pointe vers l'API réelle quand le proxy Vite ne suffit pas
 * (connexion WebSocket, contrairement au `fetch` du client HTTP, ne passe pas forcément
 * par le même proxy selon la configuration).
 */
function apiBaseUrl(): string {
  return (
    import.meta.env.VITE_API_BASE_URL ??
    (typeof window === 'undefined' ? 'http://localhost' : window.location.origin)
  );
}

/**
 * Connexion au hub SignalR des conversations support.
 *
 * `accessTokenFactory` lit le jeton depuis `authStore` (même source que le middleware
 * d'authentification du client HTTP) à CHAQUE (re)négociation — le SDK SignalR l'appelle
 * avant chaque tentative de connexion/reconnexion, donc un jeton rafraîchi entre-temps est
 * pris en compte automatiquement, sans recréer la connexion.
 *
 * Le back-office rejoint le groupe `platform-admins` côté serveur, automatiquement, à partir
 * de la revendication `platform:admin` du JWT — rien à faire ici au-delà de se connecter
 * avec le bon jeton.
 */
export function createConversationHubConnection(): HubConnection {
  return new HubConnectionBuilder()
    .withUrl(`${apiBaseUrl()}/hubs/conversations`, {
      accessTokenFactory: () => authStore.getAccessToken() ?? '',
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning)
    .build();
}
